import React from "react";
import { Controller } from "react-hook-form";
import { Autocomplete, TextField, FormControl, Typography } from "@mui/material";

const SearchSelect = ({
  name,
  control,
  data = [],
  placeholder = "Select an option",
  disabled = false,
  validation = {},
  defaultValue = null,
  width = "18.25vw",
  height = "30px",
  select = false,
  returnObject = false,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={validation}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl sx={{ width, borderRadius: "1px" }} size="small" error={!!error}>
          <Autocomplete
            options={data || []}
            getOptionLabel={(option) => (typeof option === "string" ? option : option.label)}
            isOptionEqualToValue={(option, val) => option.value === val?.value}
            value={returnObject ? value || null : data?.find((item) => item?.value === value) || null}
            onChange={(event, newValue) => {
              onChange(returnObject ? newValue : newValue?.label || "");
            }}
            disabled={disabled}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder={placeholder}
                size="small"
                disabled={disabled}
                error={!!error}
                sx={{
                  width: width || "18.25vw", // Same as in Select
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "1px",
                    height: height || "30px",
                    // Change border color to orange if error exists
                    "&.Mui-error .MuiOutlinedInput-notchedOutline": {
                      borderColor: "orange", // Apply orange border on error
                    },
                  },
                }}
              />
            )}
          />
          {error && (
            <Typography variant="caption" className="error-message">
              {error.message}
            </Typography>
          )}
        </FormControl>
      )}
    />
  );
};

export default SearchSelect;
